export default __webpack_public_path__ + "static/media/factory__11.f85bcede.jpg";